import React, { Component } from "react";

//Common Functions

import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";
import * as format from "../../../common/FormatFunctions";

//import "./CustomCSS/charts.css";
export class DashboardTools extends Component {
  constructor() {
    super();
    this.state = {
      machineState: [
        {
          colorBox: "1",
          title: "Active",
          icon: "check_circle",
          number: "13"
        },
        {
          colorBox: "3",
          title: "InActive",
          icon: "schedule",
          number: "3"
        },
        {
          colorBox: "4",
          title: "Faulty",
          icon: "report",
          number: "3"
        }
      ],
      loop: "Iteration 1"
    };
  }

  componentDidMount = () => {
    this.initialDataRender();
    this.interval = setInterval(() => this.refresh(), 5000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loading: true });

    this.setState({ loading: false });
  };

  refresh = () => {
    this.setState({ loading: true });
    console.log("Refreshing...");
    console.log(this.state);
    console.log(this.state.loop);
    var localRefreshState = format.deepCopy(this.state.loop);
    if (localRefreshState === "Iteration 1") {
      console.log("Changing Iteration 1 --> 2");
      this.setState({
        machineState: [
          {
            colorBox: "1",
            title: "Active",
            icon: "check_circle",
            number: "12"
          },
          {
            colorBox: "3",
            title: "InActive",
            icon: "schedule",
            number: "4"
          },
          {
            colorBox: "4",
            title: "Faulty",
            icon: "report",
            number: "3"
          }
        ],
        loop: "Iteration 2"
      });
    }

    if (localRefreshState === "Iteration 2") {
      console.log("Changing Iteration 2 --> 3");
      this.setState({
        machineState: [
          {
            colorBox: "1",
            title: "Active",
            icon: "check_circle",
            number: "11"
          },
          {
            colorBox: "3",
            title: "InActive",
            icon: "schedule",
            number: "5"
          },
          {
            colorBox: "4",
            title: "Faulty",
            icon: "report",
            number: "3"
          }
        ],
        loop: "Iteration 3"
      });
    }

    if (localRefreshState === "Iteration 3") {
      console.log("Changing Iteration 3 --> 1");
      this.setState({
        machineState: [
          {
            colorBox: "1",
            title: "Active",
            icon: "check_circle",
            number: "10"
          },
          {
            colorBox: "3",
            title: "InActive",
            icon: "schedule",
            number: "6"
          },
          {
            colorBox: "4",
            title: "Faulty",
            icon: "report",
            number: "3"
          }
        ],
        loop: "Iteration 1"
      });
    }
    this.setState({ loading: false });
  };

  // #endregion

  // #region View
  render() {
    return (
      <pr.Panel header="Station Overview" style={{ height: "100%" }}>
        <div className="ui-g">{this.getMachineState()}</div>
      </pr.Panel>
    );
  }

  getMachineState = () => {
    var componentArray = [];
    var index = 0;

    this.state.machineState.forEach(element => {
      componentArray[index] = (
        <div className="ui-g-12 ui-md-12 ui-lg-12">
          <div className={"ui-g card colorbox colorbox-" + element.colorBox}>
            <div className="ui-g-4">
              <i className="material-icons">{element.icon}</i>
            </div>
            <div className="ui-g-8">
              <span className="colorbox-name">{element.title}</span>
              <span className="colorbox-count">{element.number}</span>
            </div>
          </div>
        </div>
      );
      index++;
    });

    return componentArray;
  };
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardTools.js